import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import ThemeSwitcher from './ThemeSwitcher';
import { NavLink } from 'react-router-dom';
import './NavigationBar.css';

const NavigationBar = () => {
  return (
    <header className="navbar-header">
      {/* First Row */}
      <div className="header-first-row" style={{ backgroundColor: '#f1f1fb' }}>
        <div className="container d-flex justify-content-between align-items-center">
          {/* Location */}
          <div>
            <a
              href="https://maps.app.goo.gl/51JFxngzc7yKZbwH6"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'black',
                fontWeight: 'bold',
              }}
            >
              <i className="fas fa-map-marker-alt me-2"></i>
              Snow Fountain Tower, C-46, Woodland Garden, Scorpio Club Campus, Kursi Road, Lucknow
            </a>
          </div>

          {/* Mobile Number */}
          <div>
            <i
              className="fas fa-phone-square-alt me-2"
              style={{ fontSize: '16px', color: 'black' }}
            ></i>
            <strong>+91-7897651111</strong>
          </div>

          {/* Social Media Icons */}
          <div className="d-flex align-items-right social-icons">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{
                color: '#0077b5',
                fontSize: '30px',
                textDecoration: 'none',
                marginRight: '15px',
                 padding:"0px"
              }}
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{
                color: '#1877f2',
                fontSize: '30px',
                textDecoration: 'none',
                marginRight: '15px',
                marginTop: '0px',
                 padding:"0px"
              }}
            >
              <i className="fab fa-facebook-square"></i>
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{
                color: '#e4405f',
                fontSize: '30px',
                textDecoration: 'none',
                padding:"0px"
              }}
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>


      {/* Second Row */}
      <div className="header-second-row py-3">
        <Container className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <img
              src="/images/logo/logo.svg"
              alt="The Civil Lab Logo"
              className="logo img-fluid"
              style={{ maxHeight: '60px' }}
            />
            <div className="ms-3">
              <h1 className="responsive-title mb-0">
                the
                <span className="logospan">civil</span>
                lab (BETA)
              </h1>
              <h3>Website coming up soon!!</h3>
              <p className="responsive-tagline mb-0" style={{ fontSize: '14px', fontWeight: 'light', fontFamily: 'CustomFont', color: '#ccc' }}>
                Empowering Careers in Civil Engineering
              </p>
            </div>
          </div>
          <ThemeSwitcher />
        </Container>
      </div>

      {/* Third Row */}
      <Navbar expand="lg" className="navbar">
        <Container>
          {/* Hamburger Menu */}
          <Navbar.Toggle
            aria-controls="navbar-nav"
            className="navbar-toggler"
            style={{ borderColor: 'black' }}
          >
            <span className="navbar-toggler-icon" style={{ color: 'black' }}></span>
          </Navbar.Toggle>

          {/* Navigation Menu */}
          <Navbar.Collapse id="navbar-nav">
            <Nav className="mx-auto d-flex align-items-center">
              <NavLink to="/" className="me-3 navitem">
                Home
              </NavLink>
              <NavLink to="/about" className="me-3 navitem">
                About
              </NavLink>
              <NavLink to="/training" className="me-3 navitem">
                Training
              </NavLink>
              <NavLink to="/testimonials" className="me-3 navitem">
                Testimonials
              </NavLink>
              <NavLink to="/contact" className="me-3 navitem">
                Contact
              </NavLink>
              <NavLink to="/engagements" className="me-3 navitem">
                Engagements
              </NavLink>
              <NavLink to="/faq" className="me-3 navitem">
                FAQ
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavigationBar;
